import { render, staticRenderFns } from "./outdoors.vue?vue&type=template&id=3574e493&scoped=true"
import script from "./outdoors.vue?vue&type=script&lang=js"
export * from "./outdoors.vue?vue&type=script&lang=js"
import style0 from "./outdoors.vue?vue&type=style&index=0&id=3574e493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3574e493",
  null
  
)

export default component.exports